export default function VendorDirective() {
  return {
    template: require('./vendor.html'),
    scope: {
      vendor: '=',
    },
    controller: 'bcp.VendorController',
    controllerAs: 'vendorVM',
    bindToController: true,
    replace: true,
  };
}
